module.exports = __webpack_public_path__ + "static/media/subBanner.c13fc279.png";